import { useState } from 'react';
import { getApiErrorMessage } from '@/api/errors';
import useProductListMutations from '@/api/mutations/useProductListMutations';
import CustomToast from '@/components/CustomToast';
import { ProductListUpdate } from '@/models/ProductList';
import ProductListForm from '@/modules/product/components/ProductListForm';
import { ProductListEditPath } from '@/modules/product/paths';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { RectangleStackIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const ProductListAdd = () => {
  const navigate = useNavigate();
  const { createProductList } = useProductListMutations();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleOnSubmit = async (productList: ProductListUpdate) => {
    setErrorMessage(null);

    try {
      const created = await createProductList(productList);

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`Product List "${created.name}" created successfully!`}
          visible={t.visible}
        />
      ));

      navigate(ProductListEditPath.withId(created.id));
    } catch (error) {
      setErrorMessage(
        await getApiErrorMessage(error, 'Failed to create Product List. Please try again.'),
      );
    }
  };

  return (
    <>
      <SettingsHeader
        title="Create Product List"
        icon={<RectangleStackIcon className="w-6 h-6" />}
      />

      <ProductListForm onSubmit={handleOnSubmit} errorMessage={errorMessage} />
    </>
  );
};

export default ProductListAdd;
